<template>
  <div class="yy">
    <!-- 上盒子：导航菜单 -->
    <div class="yy-box1">
      <ul>
        <li><router-link to="/honor/myzs1">企业简介</router-link></li>
        <li><router-link to="/honor/myzs2">企业文化</router-link></li>
        <li><router-link to="/honor/myzs3">组织架构</router-link></li>
        <li><router-link to="/honor/myzs4">企业资质</router-link></li>
        <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
        <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
        <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
        <!-- <li><router-link to="/honor/myzs6">新闻动态</router-link></li> -->
      </ul>
    </div>

    <!-- 下盒子：证书轮播 -->
    <div class="qyzz">
      <el-carousel :interval="4000" type="card" height="800px" class="cert-carousel">
        <el-carousel-item v-for="cert in certList" :key="cert.id">
          <div class="cert-card">
            <img :src="cert.url" class="cert-img" />
            <div class="cert-name">{{ cert.name }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certList: [
        {
          id: 1,
          name: '质量管理体系认证证书',
          url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-36-910%E8%B4%A8%E9%87%8F%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg'
        },
        {
          id: 2,
          name: '食品安全管理体系认证证书',
          url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-33-854%E9%A3%9F%E5%93%81%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg'
        },
        {
          id: 3,
          name: '职业健康安全管理体系认证证书',
          url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-14-760%E8%81%8C%E4%B8%9A%E5%81%A5%E5%BA%B7%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg'
        },
        {
          id: 4,
          name: '环境管理体系认证证书',
          url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-20-920%E7%8E%AF%E5%A2%83%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg'
        },
        {
          id: 5,
          name: '危害分析与关键控制点（HACCP）体系认证证书',
          url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-51-315%E5%8D%B1%E5%AE%B3%E5%88%86%E6%9E%90%E4%B8%8E%E5%85%B3%E9%94%AE%E6%8E%A7%E5%88%B6%E7%82%B9%EF%BC%88HACCP%EF%BC%89%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg'
        }
      ]
    };
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

/* 轮播容器 */
.qyzz {
  width: 80%;
  margin: 30px auto;
}

/* 轮播卡片样式 */
.cert-carousel {
  --el-carousel-arrow-font-size: 20px;
  --el-carousel-arrow-size: 36px;
}
.cert-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cert-img {
  /* width: 100%; */
  height: calc(100% - 50px);
  object-fit: contain;      /* 确保证书完整显示，不裁剪 */
  background-color: #f5f5f5;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  padding: 12px;
}
.cert-name {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  background: #fafafa;
  border: 1px solid #f3e2e2;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .qyzz {
    width: 95%;
  }
  .cert-name {
    font-size: 14px;
    height: 45px;
    line-height: 45px;
  }
}
</style>